module.exports = __webpack_public_path__ + "img/person_index_banner.dd182c03.gif";